import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const StepContainer = styled.div`
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	padding-left: 1rem;
	padding-right: 1rem;
	gap: 0.5rem;
	min-height: 32.5rem;
`;

export const FileDropperContainerOuter = styled.div`
	border: 1px solid ${(props) => props.theme.v2.color.neutral[300]};
	border-radius: 0.25rem;
	width: 100%;
`;

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-self: center;
	justify-content: space-between;
	gap: 0.5rem;
`;

export const H3 = styled.h3`
	overflow: hidden;
	color: ${(props) => props.theme.v2.color.neutral[1100]};
	font-variant-numeric: lining-nums tabular-nums;
	text-overflow: ellipsis;

	font-family: Inter;
	font-size: 1.875rem;
	font-style: normal;
	font-weight: 600;
	line-height: 2.5rem;
`;

export const H5 = styled.h5`
	color: ${(props) => props.theme.v2.color.neutral[900]};
	font-variant-numeric: lining-nums tabular-nums;

	font-family: Inter;
	font-size: 1.0625rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.5rem;
`;

export const StepTabContainer = styled(Flex).attrs<FlexProps>({
	justify: 'center',
	align: 'center',
})`
	width: 100%;
`;

export const Header = styled.h6`
	color: ${(props) => props.theme.v2.color.neutral[1100]};
	font-variant-numeric: lining-nums tabular-nums;

	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.25rem;
`;

export const SubHeader = styled.div`
	color: ${({ theme }) => theme.color.greys[600]};
	font-variant-numeric: lining-nums tabular-nums;

	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;
`;

export const TextContainer = styled.div`
	margin-top: 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1 0 0;
`;

export const StickyFooter = styled.div`
	position: sticky;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
`;
